import { render, staticRenderFns } from "./ImportAlerts.vue?vue&type=template&id=3eae1d92"
import script from "./ImportAlerts.vue?vue&type=script&lang=js"
export * from "./ImportAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports